import { Card, CardContent, Stack, Tooltip, Typography } from '@mui/material'
import React from 'react'

import Icon from 'components/Icon'
import theme from 'theme'
import {
  ServiceReportResponse,
  ServiceReportTrendType
} from 'types/api/policies/reliability-report'
import { formatDateTime } from 'utils/formatDate'

function getTrendVariations(trendType: ServiceReportTrendType) {
  switch (trendType) {
    case 'Up':
      return {
        trendColor: 'success.main',
        trendIcon: 'solidArrowTrendUp',
        trendIndicator: '+'
      }
    case 'Down':
      return {
        trendColor: 'error.main',
        trendIcon: 'solidArrowTrendDown',
        trendIndicator: '-'
      }
    default:
      return {
        trendColor: 'text.primary',
        trendIcon: 'solidDash',
        trendIndicator: ''
      }
  }
}

const DashboardSummaryCard: React.FC<{
  service: ServiceReportResponse
}> = ({ service, ...rest }) => {
  const { trendIcon, trendColor, trendIndicator } = getTrendVariations(
    service.trendType
  )

  return (
    <Card data-test-company-dashboard-summary-card {...rest}>
      <CardContent>
        <Stack direction="column" gap={1}>
          <Tooltip arrow placement="top" title={service.serviceName}>
            <Typography
              data-test-service-name
              noWrap
              css={{ textOverflow: 'ellipsis' }}
              variant="h5"
            >
              {service.serviceName}
            </Typography>
          </Tooltip>
          <Stack alignItems="center" direction="row" gap={2}>
            <Typography variant="h4">{service.score}</Typography>
            <Typography
              color={trendColor}
              data-test-trend-type={service.trendType}
              variant="body1"
            >
              {`${trendIndicator}${service.delta}`}
              <Icon css={{ marginLeft: theme.space[1] }} icon={trendIcon} />
            </Typography>
          </Stack>

          <Stack direction="column" gap={0}>
            <Typography data-test-last-modified variant="body2">
              Last modified: {formatDateTime(service.lastModified)}
            </Typography>
            <Typography data-test-team-name variant="body2">
              {service.teamOwner.teamName}
            </Typography>
            <Typography variant="body2">
              <span data-test-team-owner>
                {service.teamOwner.teamOwnerName}
              </span>{' '}
              (
              <span data-test-team-owner-email>
                {service.teamOwner.teamOwnerEmail}
              </span>
              )
            </Typography>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  )
}

export default DashboardSummaryCard
